export const INTEGRATION_RESPONSE_ERROR_TYPES = {
  FATAL_ERROR: "integration-fatal-error",
  RETRY_ERROR: "integration-retry-error",
  TOO_MANY_REQUESTS_ERROR: "integration-too-many-requests-error",
} as const;
